import { render, staticRenderFns } from "./bankrupt-debt.vue?vue&type=template&id=687c4dde&scoped=true&"
import script from "./bankrupt-debt.vue?vue&type=script&lang=js&"
export * from "./bankrupt-debt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c4dde",
  null
  
)

export default component.exports